import React from "react";
import { Outlet } from "react-router-dom";

function ItemDetailsBranchwise() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default ItemDetailsBranchwise;
